import { ValueFormatterParams, ITooltipParams } from '@ag-grid-enterprise/all-modules';
import { SupportedFeaturesAccessFunctions } from 'data/supportedFeatures/supportedFeatures.types';

export default function getAccessFunctionTypeValueGetter(
  availableAccessFunctions: SupportedFeaturesAccessFunctions,
): (params: Partial<ValueFormatterParams> | Partial<ITooltipParams>) => string {
  return ({ data }: Partial<ValueFormatterParams> | Partial<ITooltipParams>): string => {
    const { afType } = data;
    return availableAccessFunctions[afType]?.title ?? afType;
  };
}
